// @ts-nocheck

import * as Types from '../../../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type DeleteCustomFieldDefinitionMutationVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;

export type DeleteCustomFieldDefinitionMutation = { deleteCustomFieldDefinition?: boolean | null };

export const DeleteCustomFieldDefinitionDocument = gql`
    mutation DeleteCustomFieldDefinition($id: String!) {
  deleteCustomFieldDefinition(uid: $id)
}
    ` as unknown as DocumentNode<DeleteCustomFieldDefinitionMutation, DeleteCustomFieldDefinitionMutationVariables>;
